import Vue from 'vue'
// import i18n from './i18n.js'
// import { DOCUMENT_TYPES } from '@/constants/business'

const staticFilePath = {

  // Руководства для регистрации и работы на электронной площадке
  // restoreAccessToAccountGuide: { path: 'restore_access_to_account.pdf' },
  // requisitesForPayment: { path: 'requisites_for_payment.docx' },

  // // Шаблоны документов
  // [DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT]: { path: 'userAuthorizationDocument.docx' },
  // [DOCUMENT_TYPES.ORGANIZATION_DOCUMENT]: { path: 'organizationDocument.docx' }

}

const DocumentTemplateConfigurator = {
  install (Vue) {
    Vue.getDocumentTemplateInfo = function (type) {
      let info = { path: null }
      if (type in staticFilePath && staticFilePath[type]) {
        info = staticFilePath[type]
      }

      return info
    }
  }
}

Vue.use(DocumentTemplateConfigurator)
